import React from 'react';

export default function ChessPiece({ piece }) {
  if (typeof piece !== 'string' || !/^[prnbqkPRNBQK]$/.test(piece)) return null;
  const white = piece === piece.toUpperCase();
  return (
    <img className={`chess-piece ${white ? 'piece-white' : 'piece-black'}`} src={`/chess/chessnut/${white ? 'w' : 'b'}${piece.toUpperCase()}.svg`} alt="" aria-hidden="true" draggable="false" />
  );
}

export function AgentAvatar({ side }) {
  return (
    <svg viewBox="0 0 80 80" aria-hidden="true" focusable="false">
      <path d="M40 16v-6" fill="none" stroke="currentColor" strokeWidth="3" />
      <circle cx="40" cy="8" r="4" fill="currentColor" />
      <rect x="13" y="19" width="54" height="44" rx="14" fill="currentColor" />
      <rect x="19" y="27" width="42" height="26" rx="8" fill="#19241e" />
      <rect x="7" y="34" width="7" height="15" rx="3" fill="currentColor" />
      <rect x="66" y="34" width="7" height="15" rx="3" fill="currentColor" />
      {side === 'w' ? <><circle cx="30" cy="39" r="3" fill="currentColor" /><circle cx="50" cy="39" r="3" fill="currentColor" /></> : <><circle cx="30" cy="39" r="3" fill="currentColor" /><path d="M46 38l4-2 4 2" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" /></>}
      <path d="M35 46h10" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M28 64l-2 8M52 64l2 8" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
}
